import { Routes } from '@angular/router';
import { NoAuthGuard } from './auth/helpers/noauth.guard';
import { AuthComponent } from './auth/pages/auth/auth.component';
import { PublicWishlistComponent } from './shared/components/public-wishlist/public-wishlist.component';
import { AuthGuard } from './auth/helpers/auth.guard';

export const routes: Routes = [

  // Landing Module
  { path: 'landing', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },

  { path: 'ref/:referralUser', redirectTo : '' , pathMatch: 'full' },

  // Profile Module
  { path: 'my-profile', canLoad: [AuthGuard], canActivate: [AuthGuard], loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule) },

  // Public wishlist details
  { path: 'wishlist/:id', component: PublicWishlistComponent },

  // Blog Module
  { path: 'blog', loadChildren: () => import('./blog/blog.module').then((m) => m.BlogModule) },
  { path: 'category/:slug', redirectTo: 'blog/category/:slug', pathMatch: 'full' },

  // Affiliate Module
  {
    path: 'affiliate-profile',
    loadChildren: () => import('./affiliate/affiliate.module').then((m) => m.AffiliateModule),
  },

  // Become Module

  { path: 'affiliates', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'partnerships', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },
  { path: 'sponsorship-program', loadChildren: () => import('./become/become.module').then((m) => m.BecomeModule) },

  // Help Module

  { path: 'help', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },
  { path: 'ayuda', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },
  { path: 'hilfe', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },
  { path: 'ajuda', loadChildren: () => import('./help/help.module').then((m) => m.HelpModule) },

  { path: 'login', component: AuthComponent, canActivate: [NoAuthGuard] },
  { path: 'join', component: AuthComponent, canActivate: [NoAuthGuard] },
  { path: 'forgot-password', component: AuthComponent, canActivate: [NoAuthGuard] },
  { path: 'resetpass', component: AuthComponent, canActivate: [NoAuthGuard] },


  { path: 'checkout', loadChildren: () => import('./cart/cart.module').then((m) => m.CartModule) },

  { path: 'payments', loadChildren: () => import('./confirm/confirm.module').then((m) => m.ConfirmModule) },


  // Tracks, sfx and search module

  { path: 'sound-effects', data: { soundEffect: true }, loadChildren: () => import('./tracks-sfx/tracks-sfx.module').then((m) => m.TracksSfxModule) },
  { path: 'royalty-free-music', data: { soundEffect: false }, loadChildren: () => import('./tracks-sfx/tracks-sfx.module').then((m) => m.TracksSfxModule) },

  { path: 'musica-sin-regalias', redirectTo: 'royalty-free-music' },

  // Informative module
  { path: 'about', loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule) },
  { path: 'contact', loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule) },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'terms-of-service',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'nonprofit',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'education',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'in-store-music',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  {
    path: 'licensing',
    loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule),
  },
  { path: 'premium', loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule) },
  { path: 'business', loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule) },
  { path: 'help', loadChildren: () => import('./informative/informative.module').then((m) => m.InformativeModule) },

  { path: '', loadChildren: () => import('./home/home.module').then((m) => m.HomeModule) },
  { path: '**', loadChildren: () => import('./landings/landings.module').then((m) => m.LandingsModule) },
];
